/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import HealthEntryCategoryNames from '../../constants/HealthEntryCategoryNames';
import IconAttachment from './icons/IconAttachment';
import MedliAmountAndFrequencyText from './MedliAmountAndFrequencyText';

import {
  formatSubType,
  listDateFormatMultipleOccurrence,
  listDateFormatSingleOccurrence,
} from '../../models/HealthEntryTextFormatting';
import { LocalizedDiagnosis } from '../localization/LocalizedDiagnosis';
import { useActiveUser } from '../hooks/useUser';

interface Props {
  healthEntry: any;
  className?: string;
  style?: any;
  showAttachments?: boolean;
}
const HealthEntrySubTitleText: React.FC<Props> = (props) => {
  const { healthEntry, className, showAttachments } = props;
  const style = props.style || {};

  const [{ preferredLanguageCode }] = useActiveUser();

  let amtFreqText = null;
  const subTypeText = formatSubType(healthEntry);
  let dateText = null;

  switch (healthEntry.category) {
    case HealthEntryCategoryNames.lab:
    case HealthEntryCategoryNames.measurement:
    case HealthEntryCategoryNames.geneticResult:
      if (healthEntry.values.hasValues()) {
        dateText = listDateFormatMultipleOccurrence(healthEntry);
      }
      break;
    case HealthEntryCategoryNames.allergy:
    case HealthEntryCategoryNames.condition:
      amtFreqText = MedliAmountAndFrequencyText.renderIfAmountOrFrequency(healthEntry, preferredLanguageCode);

      if (healthEntry.startDate.hasDate() || healthEntry.endDate.hasDate() || !healthEntry.diagnosis.getValue()) {
        dateText = listDateFormatSingleOccurrence(healthEntry);
      } else {
        dateText = <LocalizedDiagnosis healthEntry={healthEntry}/>;
      }

      break;
    default:
      amtFreqText = MedliAmountAndFrequencyText.renderIfAmountOrFrequency(healthEntry, preferredLanguageCode);
      dateText = listDateFormatSingleOccurrence(healthEntry);
      break;
  }

  const text = [amtFreqText, subTypeText, dateText]
    .filter(t => !!t)
    .map((t, idx) => idx > 0 ? [' - ', t] : [t])
    .reduce((acc, t) => ([...acc, ...t]), []);

  return text.length === 0
    ? null
    : (
      <span className={className} style={{ ...style, display: 'flex' }}>
        <div>
          {text.map((a, index) => <span key={index}>{a}</span>)}
        </div>
        {showAttachments && healthEntry.attachments.hasAttachments() ? <span style={{ marginLeft: 8 }}><IconAttachment.Small /></span> : null}
      </span>
    );
};

export default HealthEntrySubTitleText;
